import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import * as moment from 'moment';
import { EstadisticasServicioMedicoService } from 'app/services/estadisticas/estadisticas-servicio-medico.service';

@Component({
  selector: 'app-estadisticas',
  templateUrl: './estadisticas.component.html',
  styleUrls: ['./estadisticas.component.scss']
})
export class EstadisticasComponent implements OnInit {

  public title;

  public tipo;

  public cancelacion;

  public priodades;

  //DataTable
  public dtOptions;
  public tableOpt;
  @ViewChild(DataTableDirective, { static: true })
  tabla: DataTableDirective;
  public dtTrigger: Subject<void>

  constructor(@Inject(MAT_DIALOG_DATA) private datos, private servicios:EstadisticasServicioMedicoService) {
    this.priodades = [];
    this.servicios.prioridades().subscribe((data)=>{
        this.priodades = data;
     })

    this.title = datos.title;
    this.tableOpt = datos.servicios;

    if (this.datos.datos=='con exel') {
        this.dtOptions = {
            scrollX: true,
            scrollY: '383px',
            responsive:true,
            scrollCollapse: true,
            Processing:true,
            language: {
              sProcessing: "Procesando...",
              sLengthMenu: "Mostrar _MENU_ registros",
              sZeroRecords: "No se encontraron resultados",
              sEmptyTable: "Ningún dato disponible en esta tabla",
              sInfo: "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
              sInfoEmpty: "Mostrando registros del 0 al 0 de un total de 0 registros",
              sInfoFiltered: "(filtrado de un total de _MAX_ registros)",
              sInfoPostFix: "",
              sSearch: "Buscar:",
              sUrl: "",
              sInfoThousands: ",",
              sLoadingRecords: "Cargando...",
              oPaginate: {
                sFirst: "Primero",
                sLast: "Último",
                sNext: "Siguiente",
                sPrevious: "Anterior"
              }
            },
            dom: 'Blfrtip',
            buttons: [
                  {
                    extend: 'excel',
                    text: 'Excel'
                  }
              ]
          };
    } else {
        this.dtOptions = {
            scrollX: true,
            scrollY: '383px',
            responsive:true,
            scrollCollapse: true,
            language: {
              sProcessing: "Procesando...",
              sLengthMenu: "Mostrar _MENU_ registros",
              sZeroRecords: "No se encontraron resultados",
              sEmptyTable: "Ningún dato disponible en esta tabla",
              sInfo: "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
              sInfoEmpty: "Mostrando registros del 0 al 0 de un total de 0 registros",
              sInfoFiltered: "(filtrado de un total de _MAX_ registros)",
              sInfoPostFix: "",
              sSearch: "Buscar:",
              sUrl: "",
              sInfoThousands: ",",
              sLoadingRecords: "Cargando...",
              oPaginate: {
                sFirst: "Primero",
                sLast: "Último",
                sNext: "Siguiente",
                sPrevious: "Anterior"
              }
            }
          };
    }

  }

  ngOnInit() {
        this.cancelacion = this.tableOpt['0'].reqhcc;
        this.tipo = this.datos.tipo;
        console.log(this.datos);
  }

  getPrioridad(index: number= 0): string {
    // Obtenemos el objeto que tiene los datos del servicio del cual queremos saber su prioridad
    const objeto = this.tableOpt[index];
    // Obtenemos el ponderado el cuál sale de operar los dias y la cantidad de servicios que tiene el titular y sus beneficiarios
    const ponderado = objeto.hc_pri;
    /**
        Verificamos de que el titular sea tipo VIP o cualquiera de las opciones establecidas las cuales son
        @ApoyoVip sea igual a 1
        @ID_Titular sea igual a 7477 el cual es el id de viva cerritos el cual es un titular APE (Areas Protegidas Especiales)
        @bencba sea igual a 15 el cual nos dice que este beneficiario tiene servicios de cortesia
    */
   if(objeto.REQREG == 0){
       return 'HCM'
   }
    if (objeto.ApoyoVip === 1){
        return `VIP`;
    } else if (objeto.ID_Titular === 7477) {
        return `APE`;
    } else if (objeto.bencba === 15){
        return `COR`;
    }

    /**
     * Iteramos cada una de las prioridades que encontramos en la base de datos y verificamos si el ponderado del servicio
     * que estamos mirando esté dentro del rango de cada una de las prioridades
     */
    for(let prioridad of this.priodades){
        /**
        * +:NombreVariable signfica que estamos convirtiendo dicha variable a un numero si es un string vacio (comillas vacias) es igual a cero
        * Además si es un @NULL equivale a 0
        */
        if (+ponderado >= prioridad.rango_inicial && +ponderado<= prioridad.rango_final) {
            return prioridad.prioridad
        }
    }
 }

 tiempoCancelacion(index){
    let horallamada = moment(this.tableOpt[index].reqdia.replace(/T+[^\n]+/g, "") + " " + this.tableOpt[index].reqhor);
    let horacancelacion = moment(this.tableOpt[index].reqdia.replace(/T+[^\n]+/g, "") + " " + this.tableOpt[index].reqhcc);
    let diferencia = horacancelacion.diff(horallamada,"minutes");
    return diferencia;
 }

 tiempoReaccion(index){
    let horallamada = moment(this.tableOpt[index].reqdia.replace(/T+[^\n]+/g, "") + " " + this.tableOpt[index].reqhor);
    let horadespacho = moment(this.tableOpt[index].reqdia.replace(/T+[^\n]+/g, "") + " " + this.tableOpt[index].REQHDP);
    let diferencia = horadespacho.diff(horallamada,"minutes");

    if (Math.sign(diferencia)== -1) {
        let dia = moment(horadespacho).add(1, 'days');
        let diferenciaMenos = dia.diff(horallamada,"minutes");
        return diferenciaMenos;
    } else {
        return diferencia;
    }
 }
}
